import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { motion, useScroll, useTransform } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

interface ParallaxTitleSectionProps {
  containerRef: React.RefObject<HTMLElement>;
  title: React.ReactNode;
  content: React.ReactNode;
  startParallaxAt?: number;
}

const ParallaxTitleSection = ({
  title,
  content,
  containerRef,
  startParallaxAt = 0.5,
}: ParallaxTitleSectionProps) => {
  const titleRef = useRef<HTMLDivElement>(null);
  const scrollAreaRef = useRef<HTMLDivElement>(null);
  const [titleOffset, setTitleOffset] = useState(0);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "start end"],
  });

  const translateY = useTransform(
    scrollYProgress,
    [0.0, 0.7],
    ["-10rem", "0rem"]
  );

  useEffect(() => {
    if (titleRef.current) {
      const rect = titleRef.current.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setTitleOffset(rect.top + scrollTop);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (titleRef.current && scrollAreaRef.current) {
        // const scrollAreaRect = scrollAreaRef.current.getBoundingClientRect();
        // const titleRect = titleRef.current.getBoundingClientRect();
        // const percentageScrolled = scrollAreaRect.top / scrollAreaRect.height;
        //console.log("percentageScrolled", percentageScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [titleOffset]);

  return (
    <ParallaxScrollArea ref={scrollAreaRef}>
      <ParallaxTitle ref={titleRef}>{title}</ParallaxTitle>
      <motion.div
        style={{
          translateY: translateY,
          // marginTop: translateY,
        }}
      >
        <Content>{content}</Content>
      </motion.div>
    </ParallaxScrollArea>
  );
};

export default ParallaxTitleSection;

const ParallaxScrollArea = styled(Box)`
  position: relative;
  overflow: hidden;
`;

const ParallaxTitle = styled(Box)`
  text-transform: uppercase;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  will-change: transform;
`;

const Content = styled(Box)`
  position: relative;
  z-index: 2;
`;
